import { template } from "@ember/template-compiler";
import DButton from "discourse/components/d-button";
const BulkSelectToggle = template(`
  <DButton
    class="bulk-select"
    @action={{@bulkSelectHelper.toggleBulkSelect}}
    @icon="list"
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BulkSelectToggle;
